import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import contactIcon from '../../../assets/contact-icon.svg';
import logoWhite from '../../../assets/logoWhite.svg';
import { Dropdown } from 'react-bootstrap';
import { factoryCards } from '../../../constants';
import { authActions } from '../../../store/slices';
import { persistor } from '../../../store';
import { logout } from '../../../service/auth';

function Navbar() {
    let navigate = useNavigate();
    const dispatch = useDispatch();

    const handleClick = (path, label) => {
        if (label === 'Çıkış Yap') {
            logout();
            persistor.purge();
            dispatch(authActions.setIsLoggedOut)
            return;
        }
        navigate(`/factory/${path}`);
    }
    
    return (
        <header className="main-container">
            <div className="navbar-logo-container" onClick={() => { navigate('/factory') }}>
                <img className='logo' src={logoWhite} alt="logo-white" />
            </div>
            <div className="user-credentials">
                <div className="user-img">
                    <img src={contactIcon} alt="contact-icon" />
                </div>
                <Dropdown>
                    <Dropdown.Toggle variant='primary' id='dropdown-basic'>
                        Menü
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {
                            factoryCards.map(card => {
                                const { navPath, label, id } = card;
                                return (
                                    <Dropdown.Item key={id} onClick={() => { handleClick(navPath, label) }}>
                                        {label}
                                    </Dropdown.Item>
                                )
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </header>
    );
}

export default Navbar;